export enum IntegrationHeaders {
    AVIATOR_INTEGRATION_TYPE = 'AVIATOR-INTEGRATION-TYPE',
    AVIATOR_INTEGRATION_TOKEN = 'AVIATOR-INTEGRATION-TOKEN',
    AVIATOR_STRIPE_SESSION_TOKEN = 'AVIATOR-STRIPE-SESSION-TOKEN',
    AVIATOR_AFTER_AUTHENTICATION_REDIRECT = 'AVIATOR-AFTER-AUTHENTICATION-REDIRECT',
}